import { render, staticRenderFns } from "./association-food.vue?vue&type=template&id=26e47324&scoped=true&"
import script from "./association-food.vue?vue&type=script&lang=js&"
export * from "./association-food.vue?vue&type=script&lang=js&"
import style0 from "./association-food.vue?vue&type=style&index=0&id=26e47324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e47324",
  null
  
)

export default component.exports